import { render, staticRenderFns } from "./dynamicForms.vue?vue&type=template&id=116878a3&scoped=true"
import script from "./dynamicForms.vue?vue&type=script&lang=js"
export * from "./dynamicForms.vue?vue&type=script&lang=js"
import style0 from "./dynamicForms.vue?vue&type=style&index=0&id=116878a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116878a3",
  null
  
)

export default component.exports